import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
// Request DTO 직접 정의 (OAISchema 금지 — api-typegen §0)
type ShoppingCartItemFixQuantityRequest = {
  quantity: number;
  skuId: number;
};

/** 장바구니 수량 갱신 요청 (일반/바로구매 공용) */
export type UpdateShoppingCartQuantityRequest = {
  clear?: boolean;
  offerId: number;
  stockKeepingUnits: ShoppingCartItemFixQuantityRequest[];
};

export interface CartDataSource {
  getCartCount(): Promise<number>;
  // Mutation
  updateECouponQuick(offerId: number): Promise<void>;
  updateCartQuantity(
    requestBody: UpdateShoppingCartQuantityRequest,
  ): Promise<void>;
  updateQuickQuantity(
    requestBody: UpdateShoppingCartQuantityRequest,
  ): Promise<void>;
}

export class CartDataSourceImpl implements CartDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getCartCount() {
    return this.client.request<number>({
      url: '/api/market-place/v1/shopping-cart-items/count',
      method: 'get',
    });
  }

  async updateECouponQuick(offerId: number) {
    await this.client.request<void>({
      url: '/api/market-place/v2/shopping-cart-items/quick/e-coupon',
      method: 'put',
      data: { offerId },
    });
  }

  async updateCartQuantity(requestBody: UpdateShoppingCartQuantityRequest) {
    await this.client.request<void>({
      url: '/api/market-place/v2/shopping-cart-items/quantity',
      method: 'put',
      data: requestBody,
    });
  }

  async updateQuickQuantity(requestBody: UpdateShoppingCartQuantityRequest) {
    await this.client.request<void>({
      url: '/api/market-place/v2/shopping-cart-items/quick/quantity',
      method: 'put',
      data: requestBody,
    });
  }
}

export const cartDataSource = new CartDataSourceImpl();
